import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import FavoriteIcon from '@material-ui/icons/Favorite';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';

function CircularProgressWithLabel(props) {
    const classes = useStylesFacebook();
    const intl = useIntl();

    return (
        <Backdrop open={props.open}
            // style={{ zIndex: 10 }}
            className={props.open === false ? null : classes.displayNone}
            invisible={true}
        >
            <Box position="relative" display="inline-flex">
                <CircularProgress
                    thickness={4}
                    size={250}
                    variant="determinate"
                    className={classes.bottom}
                    value={100}
                // classes={{circle: classes.circle}}
                />
                <CircularProgress
                    thickness={4}
                    size={250}
                    variant="determinate"
                    className={classes.top}
                    classes={{ circle: classes.circle }}
                    style={{ borderRadius: "5px" }}
                    {...props}
                />
                <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >


                    <Typography
                        variant="h6"
                        component="div"
                        color="textSecondary"
                        style={{ fontWeight: "bolder", color: "black", textAlign: "center", paddingBottom: "40px" }}
                    >
                        <FormattedMessage id={"app.ThankDone"} />
                        {/* {"全部已完成"}  */}
                        <br></br>
                        {/* {"感謝您的耐心填寫"} */}
                        <FormattedMessage id={"app.ThankWords"} />
                        <FavoriteIcon size={"large"} style={{ color: "red" }} />

                    </Typography>
                    <Typography
                        variant="h3"
                        component="div"
                        color="textSecondary"
                        style={{
                            fontWeight: "bolder",
                            paddingTop: "75px",
                            position: "absolute", color: "black"
                        }}
                    >{`${Math.ceil((100 - props.value) / 20)}`}
                    </Typography>
                </Box>
            </Box>
        </Backdrop>
    );
}
const useStylesFacebook = makeStyles((theme) => ({
    root: {
        position: "relative"
    },
    bottom: {
        color: theme.palette.grey[theme.palette.type === "light" ? 200 : 700]
    },
    displayNone: {
        zIndex: "2",
        backgroundColor: "white"    //白底
    },
    colorPrimary: {
        // color: theme.palette.red[theme.palette.type === 'light' ? 200 : 700],
    },
    top: {
        // color: "#1a90ff",
        // animationDuration: "0ms",
        position: "absolute",
        // transitionDuration:"0ms",
        // transitionDelay:"0ms",
        // transform:"0s",
        // left: 0
    },
    circle: {
        strokeLinecap: 'round', //圓弧進度
    }
}));
CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired
};

export default function CircularStatic(props) {
    const [progress, setProgress] = React.useState(0);
    // const [open, setOpen] = React.useState(true);
    const initialRender = React.useRef(true);

    const { open } = props;
    // let open = props.backdrop;
    // const setOpen = props.setOpen;
    // console.log(open)
    React.useEffect(() => {
        let timer;
        // console.log("start")
        // console.log(open)


        if (open) {
            timer = setInterval(() => {
                setProgress((prevProgress) =>
                    prevProgress >= 100 ? 100 : prevProgress + 2
                );
            }, 100);
        }

        // clearInterval(timer);


        // console.log(setOpen)

        return () => {
            clearInterval(timer);
            // setOpen(false);
            // console.log("end")
        };
    }, [open]);

    return <CircularProgressWithLabel value={progress} open={open} />;
}
